import { Expose } from 'class-transformer'

export default class LeadMatchedJobFormError {
  availability_check_id: string[] = []
  @Expose({ name: '_schema' }) schema: string[] = []
}
